import Cookies from "js-cookie";

export const getCountry = (inputCountry = "") => {
  let country = Cookies.get("countrySelected");
  if (country) {
    return country;
  }

  if (inputCountry !== "") {
    return inputCountry;
  }

  return "USA";
};
